/* Serving sizes */
export const ServingSizeOptions = {
  '1': '1',
  '2': '2',
  '3': '3',
  '4': '4',
} as const;
export type ServingSizeOptionsType = keyof typeof ServingSizeOptions;

/* eslint-disable sort/object-properties */
/* Difficulty */
export const DifficultyOptions = {
  easy: 'Easy',
  medium: 'Medium',
  hard: 'Hard',
} as const;
/* eslint-enable sort/object-properties */
export type DifficultyOptionsType = keyof typeof DifficultyOptions;

/* eslint-disable sort/object-properties */
/* Ingredient amounts
TODO gavalas add a "section" type where the name is the section name which can 
make it so our ingredients can be grouped together.
 */
export const AmountsOptions = {
  '1/8_tsp': '1/8 tsp',
  '1/4_tsp': '1/4 tsp',
  '1/2_tsp': '1/2 tsp',
  '3/4_tsp': '3/4 tsp',
  '1_tsp': '1 tsp',
  '2_tsp': '2 tsp',
  '3_tsp': '3 tsp',
  '4_tsp': '4 tsp',
  '1/8_tbsp': '1/8 tbsp',
  '1/4_tbsp': '1/4 tbsp',
  '1/2_tbsp': '1/2 tbsp',
  '3/4_tbsp': '3/4 tbsp',
  '1_tbsp': '1 tbsp',
  '2_tbsp': '2 tbsp',
  '3_tbsp': '3 tbsp',
  '4_tbsp': '4 tbsp',
  '1/8_cup': '1/8 cup',
  '1/4_cup': '1/4 cup',
  '1/3_cup': '1/3 cup',
  '1/2_cup': '1/2 cup',
  '3/4_cup': '3/4 cup',
  '1_cup': '1 cup',
  '1_1/4_cup': '1 1/4 cup',
  '1_1/3_cup': '1 1/3 cup',
  '1_1/2_cup': '1 1/2 cup',
  '1_3/4_cup': '1 3/4 cup',
  '2_cup': '2 cup',
  '3_cup': '3 cup',
  '4_cup': '4 cup',
  '5_cup': '5 cup',
  '6_cup': '6 cup',
  '7_cup': '7 cup',
  '8_cup': '8 cup',
  '1/4_whole': '1/4',
  '1/2_whole': '1/2',
  '3/4_whole': '3/4',
  '1_whole': '1',
  '2_whole': '2',
  '3_whole': '3',
  '4_whole': '4',
  '5_whole': '5',
  '6_whole': '6',
  '7_whole': '7',
  '8_whole': '8',
  none: '',
} as const;
/* eslint-enable sort/object-properties */
export type AmountsOptionsType = keyof typeof AmountsOptions;

export type RecipeStep = {
  description: string;
  id: string;
  title: string;
};

export type RecipeIngredient = {
  amount: AmountsOptionsType;
  extraNotes: string;
  id: string;
  name: string;
  stepId: string | null;
};

/* Root recipe type */
export interface Recipe {
  cookMinutes: number;
  created: string;
  description: string;
  difficulty: DifficultyOptionsType;
  featured: boolean;
  friendlyUrl: string;
  id: string;
  imageUrl: string;
  ingredients: RecipeIngredient[];
  modified: string;
  name: string;
  prepMinutes: number;
  published: boolean;
  servings: ServingSizeOptionsType;
  steps: RecipeStep[];
}
